export const GET_POLICY_DETAILS = 'PolicyDetails/GET_POLICY_DETAILS';
export const SET_POLICY_DETAILS = 'PolicyDetails/SET_POLICY_DETAILS';
export const SET_POLICY_DETAILS_ERROR = 'PolicyDetails/SET_POLICY_DETAILS_ERROR';
export const CLEAR_POLICY_DETAILS = 'PolicyDetails/CLEAR_POLICY_DETAILS';
export const CLEAR_POLICY_DETAILS_ERROR = 'PolicyDetails/CLEAR_POLICY_DETAILS_ERROR';
